import React from 'react';
import { OnboardingStep, StepItem } from 'hooks/useOnboardingSteps';
import OnboardingModuleStep from '../OnboardingModuleStep';
import './OnboardingModuleSteps.scss';

const BASE_CLASS = 'OnboardingModuleSteps';

interface Props {
  steps: StepItem[];
  completedSteps: OnboardingStep[];
  activeStep: StepItem;
  onStepAction: (step: OnboardingStep) => void;
  onStepToggleComplete: (step: OnboardingStep, completed: boolean) => void;
}
export default function OnboardingModuleSteps({
  steps,
  onStepAction,
  completedSteps,
  activeStep,
  onStepToggleComplete,
}: Props) {
  return (
    <div className={BASE_CLASS}>
      {steps.map(({ id, ...rest }) => {
        const isCompleted = completedSteps.includes(id);

        return (
          <OnboardingModuleStep
            key={id}
            isActive={activeStep.id === id}
            isCompleted={isCompleted}
            onAction={() => onStepAction(id)}
            onToggleComplete={() => onStepToggleComplete(id, !isCompleted)}
            {...rest}
          />
        );
      })}
    </div>
  );
}
